// containerHelpers.js
// Same container add/update/remove pattern LeaveRequest.js uses for
// DEPCONTAINERS - reused unchanged since it operates generically on whatever
// ContainerFields array it's given, keyed by field name (not position).

import moment from 'moment';

export function updateContainerFieldValue(stageFields, containerFieldKey, rowIndex, childFieldKey, newValue) {
    const containerField = stageFields[containerFieldKey];
    const rows = [...containerField.ContainerFields];
    const row = { ...rows[rowIndex] };
    const existing = row[childFieldKey];

    row[childFieldKey] = { ...existing, FieldValue: newValue };
    rows[rowIndex] = row;

    return {
        ...stageFields,
        [containerFieldKey]: { ...containerField, ContainerFields: rows },
    };
}

export function addContainerRow(stageFields, containerFieldKey, newRow) {
    const containerField = stageFields[containerFieldKey];
      const existing = containerField.ContainerFields ?? []; 
    const rows = [...containerField.ContainerFields, newRow];
    return {
        ...stageFields,
        [containerFieldKey]: { ...containerField, ContainerFields: rows },
    };
}

export function removeContainerRow(stageFields, containerFieldKey, rowIndex) {
    const containerField = stageFields[containerFieldKey];
    const rows = containerField.ContainerFields.filter((_, i) => i !== rowIndex);
    return {
        ...stageFields,
        [containerFieldKey]: { ...containerField, ContainerFields: rows },
    };
}

// Flattens a stageFields object (including nested ContainerFields rows) into
// the RequestAttributes array shape the backend expects - same shape
// LeaveRequest.js's saveRequest() builds, field by field.
export function flattenToRequestAttributes(stageFields, { stageNum, processNum, companyId, stageSequence }) {
    const attributes = [];
    let fieldSequence = 1;

    const serializeFieldValue = (fieldValue) => {
        if (fieldValue === null || fieldValue === undefined) {
            return fieldValue;
        }

        if (Array.isArray(fieldValue)) {
            return JSON.stringify(fieldValue);
        }

        if (typeof fieldValue === 'object') {
            return JSON.stringify(fieldValue);
        }

        return fieldValue;
    };

    const pushAttr = (field, childRowNmbr) => {
        const isDate = field.FieldType === 7 || field.FieldType === 8; // DATETIMEPICKER / DATEPICKER
        const rawFieldValue = isDate && field.FieldValue ? moment(field.FieldValue).format('MM/DD/YYYY') : field.FieldValue;
        attributes.push({
            ChildRowNmbr: childRowNmbr,
            DataType: field.DataType,
            FieldDescription: field.FieldLabel,
            FieldName: field.FieldName,
            FieldType: field.FieldType,
            FieldValue: serializeFieldValue(rawFieldValue),
            ParentFieldId: field.ParentFieldId,
            stageNum,
            processNum,
            FieldSequence: fieldSequence++,
            IsActive: true,
            CompanyID: companyId,
            StageSequence: stageSequence,
            ContainerType: field.type,
            ...(field.FieldId ? { FieldId: field.FieldId } : {}),
        });
    };

    Object.values(stageFields).forEach((field) => {
        if (field.ContainerFields === null) {
            pushAttr(field, field.ChildRowNmbr);
            return;
        }
        // Container marker field itself
        pushAttr(field, 1);
        // Each row's child fields
        field.ContainerFields.forEach((row, rowIndex) => {
            Object.values(row).forEach((childField) => {
                pushAttr(childField, rowIndex + 1);
            });
        });
    });

    return attributes;
}
